const variables = require('../../../variables/Variables.js');
const apiUrl = variables.apiUrl;

function getStaticUrlAsync(id) {
    const fetchUrl = apiUrl + 'asset/url?id=' + id;
    return new Promise((resolve, reject) => {
        fetch(fetchUrl)
        .then(response => {
            if (response.status === 200) {
                return response.json();
            } else {
                throw new Error('Fetch static asset url failed with code ' + response.status);
            }
        })
        .then(responseJson => resolve(responseJson))
        .catch(error => reject(error));
    });
}

export const NavMarkerSpriteName = Object.freeze({
    NORMALLEFT: 'NavMarkerNormalLeft',
    NORMALRIGHT: 'NavMarkerNormalRight',
    NORMALUP: 'NavMarkerNormalUp',
    NORMALDOWN: 'NavMarkerNormalDown',
    NORMALUPLEFT: 'NavMarkerNormalUpLeft',
    NORMALDOWNLEFT: 'NavMarkerNormalDownLeft',
    NORMALUPRIGHT: 'NavMarkerNormalUpRight',
    NORMALDOWNRIGHT: 'NavMarkerNormalDownRight',
    NORMALSTAIRSUP: 'NavMarkerNormalStairsUp',
    NORMALSTAIRSDOWN: 'NavMarkerNormalStairsDown',
    HOVERLEFT: 'NavMarkerHoverLeft',
    HOVERRIGHT: 'NavMarkerHoverRight',
    HOVERUP: 'NavMarkerHoverUp',
    HOVERDOWN: 'NavMarkerHoverDown',
    HOVERUPLEFT: 'NavMarkerHoverUpLeft',
    HOVERDOWNLEFT: 'NavMarkerHoverDownLeft',
    HOVERUPRIGHT: 'NavMarkerHoverUpRight',
    HOVERDOWNRIGHT: 'NavMarkerHoverDownRight',
    HOVERSTAIRSUP: 'NavMarkerHoverStairsUp',
    HOVERSTAIRSDOWN: 'NavMarkerHoverStairsDown',
    FADELEFT: 'NavMarkerFadeLeft',
    FADERIGHT: 'NavMarkerFadeRight',
    FADEUP: 'NavMarkerFadeUp',
    FADEDOWN: 'NavMarkerFadeDown',
    FADEUPLEFT: 'NavMarkerFadeUpLeft',
    FADEDOWNLEFT: 'NavMarkerFadeDownLeft',
    FADEUPRIGHT: 'NavMarkerFadeUpRight',
    FADEDOWNRIGHT: 'NavMarkerFadeDownRight',
    FADESTAIRSUP: 'NavMarkerFadeStairsUp',
    FADESTAIRSDOWN: 'NavMarkerFadeStairsDown'
});

export function getHeartFillUrlAsync() {
    return getStaticUrlAsync('HeartFill');
}

export function getHeartEmptyUrlAsync() {
    return getStaticUrlAsync('HeartEmpty');
}

export function getNavMarkerUrlAsync(spriteName) {
    return getStaticUrlAsync(spriteName);
}

export function getProductMarkerNormalAsync() {
    return getStaticUrlAsync('ProductMarkerNormal');
}

export function getProductMarkerHoverAsync() {
    return getStaticUrlAsync('ProductMarkerHover');
}

export function getVideoMarkerNormalAsync() {
    return getStaticUrlAsync('VideoMarkerNormal');
}

export function getModalCloseIconNormalAsync() {
    return getStaticUrlAsync('ModalCloseIconNormal');
}

export function getModalCloseIconHoverAsync() {
    return getStaticUrlAsync('ModalCloseIconHover');
}

export function getDragToSpinAsync() {
    return getStaticUrlAsync('DragToSpin');
}

export function getDragToSpinIconAsync() {
    return getStaticUrlAsync('DragToSpinIcon');
}

export function getFacebookAsync() {
    return getStaticUrlAsync('FacebookIcon');
}

export function getTwitterAsync() {
    return getStaticUrlAsync('TwitterIcon');
}

export function getVideoPlayAsync() {
    return getStaticUrlAsync('VideoPlay');
}

export function getObsessLogoAsync() {
    return getStaticUrlAsync('ObsessLogo');
}

export function getObsessUrlAsync() {
    return getStaticUrlAsync('ObsessUrl');
}

export function getWelcomeExploreUrlAsync() {
    return getStaticUrlAsync('WelcomeExplore');
}

export function getZoomIconUrlAsync() {
    return getStaticUrlAsync('ZoomIcon');
}

export const spotifyModalHotspotIds  = [
    "622882936b1b19ea36ee5e4e"
]

export function getDirectoryMenu() {
    let menuList = [
        {
            name: 'Central watch bar',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu:[
                {
                    name:'Egerie',
                    sceneId: '6213fad20b6a1d285d429f0b' // view-10
                },
                {
                    name:'Fiftysix',
                    sceneId: '6213efb90b6a1d285d429e77' // view-6-b
                },
                {
                    name:'Patrimony',
                    sceneId: '60db66a837950a94f897bfb4' // view-6-a
                }
            ]
        },
        {
            name: 'Discovery table',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu:[
                {
                    name:'Heures Créatives',
                    sceneId: '6213ed730b6a1d285d429e55' // view-2-c
                },
                {
                    name:'Métiers d art',
                    sceneId: '6213f05c0b6a1d285d429e7c' // view-5-a
                }
            ]
        },
        {
            name: 'Window exhibition',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu:[
                {
                    name:'Malte',
                    sceneId: '6213eec70b6a1d285d429e6f' // view-3-a
                },
                {
                    name:'Fiftysix',
                    sceneId: '60b124d24ebbe9679e17714f' // window-1
                },
                {
                    name:'Egerie',
                    sceneId: '6213eef90b6a1d285d429e71' // view-3-b
                }
            ]
        },
        {
            name: 'Experience area',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu:[
                {
                    name:'Historiques',
                    sceneId: '60db676e37950a94f897bfb7' // experience-area
                }
            ]
        },
        {
            name: 'Watch counter',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu:[
                {
                    name:'Patrimony',
                    sceneId: '60db66d637950a94f897bfb5' // view-8
                },
                {
                    name:'Traditionnelle',
                    sceneId: '60db66c1c584ff71d1029bec' // view-7
                }
            ]
        },
        {
            name: 'Samaritan bar',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu:[
                {
                    name:'Malte',
                    sceneId: '608b35849ab97c255a2aabad' // sales-area-3-b
                },
                {
                    name:'Traditionnelle',
                    sceneId: '6213f75a0b6a1d285d429edb' // sales-area-3-a
                }
            ]
        }
    ]

    return menuList;
}

export function getFloorMenu() {
    const storeId = variables.storeId;
    let menuData = [
        {
            name: 'Floor 1',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu: [
                {
                    name: '1',
                    imageUrl: "https://cdn.obsess-vr.com/vacheron/Floor_1.png",
                    pins: [
                        {
                            name: 'CENTRAL WATCH BAR', // view-6-a
                            sceneId: '60db66a837950a94f897bfb4',
                            x: '72',
                            y: '94'
                        },
                        {
                            name: 'DISCOVERY TABLE', // exhibition-area-1
                            sceneId: '608b3559a1d90c9fe80ab2bc',
                            x: '34',
                            y: '95'
                        },
                        {
                            name: 'WINDOW EXHIBITION', // view-3-b
                            sceneId: '6213eef90b6a1d285d429e71',
                            x: '22',
                            y: '44'
                        },
                        {
                            name: 'EXPERIENCE AREA', // experience-area
                            sceneId: '60db676e37950a94f897bfb7',
                            x: '113',
                            y: '94'
                        },
                        {
                            name: 'WATCH COUNTER', // view-8
                            sceneId: '60db66d637950a94f897bfb5',
                            x: '79',
                            y: '49'
                        }
                    ]
                }
            ]
        },
        {
            name: 'Floor 2',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu: [
                {
                    name: '1',
                    imageUrl: "https://cdn.obsess-vr.com/vacheron/Floor_2.png",
                    pins: [
                        {
                            name: 'SAMARITAN BAR', // sales-area-3-a
                            sceneId: '6213f75a0b6a1d285d429edb',
                            x: '31',
                            y: '53'
                        },
                        {
                            name: 'SALON AREA', // exclusive-area-2-a
                            sceneId: '60db682a37950a94f897bfbc',
                            x: '137',
                            y: '90'
                        }
                    ]
                }
            ]
        }
    ];
    
    return menuData;
}
// offset views
export const customViewOffsetIds = Object.freeze({
    //chronogram
    '608b35749ab97c255a2aabac': {
        leftAngle: -2,
        upAngle: 13
    },
    //view-5-c
    '6213f0830b6a1d285d429e7e': {
        leftAngle: 0,
        upAngle: 8
    },
    //view-6-b
    '6213efb90b6a1d285d429e77': {
        leftAngle: 0,
        upAngle: 12
    },
    //view-6-c
    '6213efd90b6a1d285d429e79': {
        leftAngle: 0,
        upAngle: 12
    },
    //view-10
    '6213fad20b6a1d285d429f0b': {
        leftAngle: 0,
        upAngle: 14
    },
    //heritage-wall
    '6088955027bbf54e525286d1': {
        leftAngle: 0,
        upAngle: -14
    },
    //experience-area-2
    '6213f2ad0b6a1d285d429e85': {
        leftAngle: 0,
        upAngle: -10
    },
    //experience-area-3
    '6213f2d70b6a1d285d429e87': {
        leftAngle: 0,
        upAngle: -12
    },
    //sales-area-2-a
    '608b35939ab97c255a2aabae': {
        leftAngle: 0,
        upAngle: -12
    },
    //view-2-a
    '6213ed350b6a1d285d429e4a': {
        leftAngle: 0,
        upAngle: 8
    },
    //view-2-c
    '6213ed730b6a1d285d429e55': {
        leftAngle: 0,
        upAngle: 10
    },
    //sales-area-2-b
    '6213f48d0b6a1d285d429eb7': {
        leftAngle: 0,
        upAngle: -7
    },
    //sales-area-3-b
    '608b35849ab97c255a2aabad': {
        leftAngle: 0,
        upAngle: 20
    },
    //exclusive-area-2-b
    '6213f6640b6a1d285d429ed6': {
        leftAngle: 0,
        upAngle: 10
    },
})

export const getTextModalVideo = {
    "6230ea278ef4d70293cd1297": "https://cdn.obsess-vr.com/vacheron/Enameler.mp4",
    "6230ea278ef4d70293cd1298": "https://cdn.obsess-vr.com/vacheron/Engraver.mp4",
    "6230e447da6c159034edb58f": "https://cdn.obsess-vr.com/vacheron/Enameler.mp4",
    "6230eaec8ef4d70293cd1299": "https://cdn.obsess-vr.com/vacheron/Engraver.mp4",
    "6230edea8ef4d70293cd12a1": "https://cdn.obsess-vr.com/vacheron/Guillocheur.mp4",
    "6230ebfeda6c159034edb59c": "https://cdn.obsess-vr.com/vacheron/Jeweler-Gemsetter.mp4",
    "6230eef4da6c159034edb5a0": "https://cdn.obsess-vr.com/vacheron/Guillocheur.mp4",
    "6230eb98f643a2bbc225feb8": "https://cdn.obsess-vr.com/vacheron/Jeweler-Gemsetter.mp4",
    "6230e7bbda6c159034edb592": "https://cdn.obsess-vr.com/vacheron/Enameler.mp4",
    "6230ea7df643a2bbc225feb6": "https://cdn.obsess-vr.com/vacheron/Engraver.mp4",
}